<template>
  <div class="main">
    <div class="top"></div>
    <div class="body">
      <div v-if="statistic" class="yet">
        <div v-if="statistic.images.length" class="photo">
          <img
            v-for="(item, i) of statistic.images"
            :key="i"
            :src="item"
            alt=""
            class="item"
          />
        </div>
        <span v-if="statistic.join_type == 1" class="text"
          >已有{{ statistic.join_value }}人正在参与销巴拼团</span
        >
        <span v-else class="text">人气值{{ statistic.join_value }}</span>
      </div>
      <div class="block">
        <div class="goods">
          <div class="icon">
            <img :src="D.thumb" alt="" class="img" />
            <div v-if="D.group_status == 5" class="tip">已拼完</div>
          </div>
          <div class="info">
            <div class="title">{{ D.goods_name }}</div>
            <div class="moods">
              <img src="@/assets/groupBuy/fire.png" alt="" class="icon" />
              <span>人气值 {{ D.views_count }}</span>
            </div>
            <div class="money">
              <span class="old">¥{{ D.strikeout_price }}</span>
              <div class="now">
                <span>￥</span>
                <span class="large">{{ D.activity_price }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="countdown">
          <span class="label">距结束</span>
          <span class="item">{{ time("hour") }}</span>
          <span class="divider">：</span>
          <span class="item">{{ time("minute") }}</span>
          <span class="divider">：</span>
          <span class="item">{{ time("second") }}</span>
        </div>
        <div class="photo">
          <div class="item head">
            <img :src="D.head_pic || user" alt="" class="item" />
            <img src="@/assets/groupBuy/crown.png" alt="" class="crown" />
          </div>
          <img src="@/assets/groupBuy/unknow.png" alt="" class="item" />
        </div>
        <span v-if="D.specification_name" class="spec"
          >团长所选规格：{{ D.specification_name }}</span
        >
        <div v-if="D.group_status == 2" class="desc">
          <span>你的好友已拼成功，可参与以下进行中的拼团剩余</span>
          <span class="active">{{ D.group_num }}个</span>
          <span>名额</span>
        </div>
        <div v-else-if="D.group_status == -1" class="desc">
          <span>你的好友已拼失败，可参与以下进行中的拼团剩余</span>
          <span class="active">{{ D.group_num }}个</span>
          <span>名额</span>
        </div>
        <div v-else-if="D.group_status == 3" class="desc">
          <span>该团已拼成功，无法继续参与</span>
        </div>
        <div v-else-if="D.group_status == 4" class="desc">
          <span>该团已拼失败，无法继续参与</span>
        </div>
        <div v-else-if="D.group_status == 5" class="desc">
          <span>该商品已拼完，无法继续参与</span>
        </div>
        <div v-else class="desc">
          <span>仅剩</span>
          <span class="active">{{ D.group_num }}个</span>
          <span>名额</span>
        </div>
        <div
          style="align-self: center"
          v-if="D.group_status != 5"
          v-html="renderDom"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getQuery } from "./utils";
import Utils from "@/providers/utils";

export default {
  data() {
    return {
      id: null,
      D: {},
      timer: null,
      seconds: 0,
      downStr: null,
      statistic: null,
      user: require("@/assets/common/avatar.png"),
    };
  },
  mounted() {
    this.id = getQuery("id", location.href);
    this.getDetail();
    document.documentElement.style.setProperty(
      "font-size",
      (document.body.clientWidth / 375) * 10 + "px"
    );
    this.$api
      .post("member/index/wechat/get/sign/package", {
        type: 1,
        url: location.href,
      })
      .then((res) => {
        wx.config({
          debug: false,
          appId: res.appId,
          nonceStr: res.nonceStr,
          signature: res.signature,
          timestamp: res.timestamp,
          jsApiList: ["checkJsApi"],
          openTagList: ["wx-open-launch-weapp"],
        });
      });
  },
  computed: {
    time() {
      return (type) => {
        let _temp = this.seconds;
        if (_temp < 0) {
          return "00";
        }
        let hour = Math.floor(_temp / 60 / 60);
        _temp -= hour * 60 * 60;
        let minute = Math.floor(_temp / 60);
        _temp -= minute * 60;
        let second = _temp.toString().padStart(2, "0");
        switch (type) {
          case "hour":
            return hour.toString().padStart(3, "0");
          case "minute":
            return minute.toString().padStart(2, "0");
          case "second":
            return second.toString().padStart(2, "0");
          default:
            return "00";
        }
      };
    },
    renderDom() {
      let _script = document.createElement("script");
      _script.type = "text/wxtag-template";
      _script.text =
        "<style> .btn { align-self: center; width: 240px; height: 44px; font-size: 15px; font-weight: 600; color: #fff; background: linear-gradient(180deg, #fe704f 0, #ff263b 100%); border-radius: 22px; display: flex; justify-content: center; align-items: center; } </style>";
      if (this.D.group_status == 1) {
        _script.text += `<div class="btn">参与“${this.D.member_name}”的拼团</div>`;
      } else if (this.D.group_status == 3 || this.D.group_status == 4) {
        _script.text += `<div class="btn">开新团</div>`;
      } else {
        _script.text += `<div class="btn">立即参团</div>`;
      }
      let html = `<wx-open-launch-weapp id="launch-btn" class="btn" username="gh_d09812b9e2e1" path="pages/goods/detail/index.html?id=${this.D.goods_id}&fromPt=1&groupId=${this.D.group_id}" > ${_script.outerHTML} </wx-open-launch-weapp> `;
      return html;
    },
  },
  methods: {
    getDetail() {
      this.$api
        .post("onorder/index/order/group-share", { group_id: this.id })
        .then((res) => {
          console.log(res);
          this.getStatistic(res.activity_id);
          this.seconds = parseInt(
            (+Utils.date(res.group_end_at) - +Utils.date()) / 1000
          );
          this.D = res;
          if (!res.activity_status) {
            return this.$router.replace("/groupbuy/finish");
          }
          if (this.D.group_status == 3 || this.D.group_status == 4) {
            this.D.group_id = "";
          }
          this.startCountDown();
        });
    },
    getStatistic(activity_id) {
      this.$api
        .get("activity/index/get/activity/stat", { activity_id })
        .then((res) => {
          res.images = res.images.slice(0, 3);
          this.statistic = res;
        });
    },
    startCountDown() {
      this.timer = setInterval(() => {
        this.seconds--;
        if (this.seconds <= 0) {
          clearInterval(this.timer);
          this.seconds = 0;
        }
      }, 1000);
    },
  },
  beforeDestroy() {
    this.timer && clearInterval(this.timer);
  },
};
</script>

<style lang="less" scoped>
.main {
  height: 100vh;
  background: linear-gradient(88deg, #ff4f35 0%, #ff263b 100%);
  position: relative;
  overflow: auto;

  .top {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 19.2rem;
    background: url(~@/assets/groupBuy/share-bg.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }

  .body {
    margin-top: 17.5rem;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: stretch;

    .yet {
      align-self: center;
      width: 30.3rem;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(0, 0, 0, 0.19);
      height: 3rem;
      border-radius: 1.5rem;

      .photo {
        display: flex;
        margin-right: 0.9rem;

        .item {
          width: 1.8rem;
          height: 1.8rem;
          border: 0.2rem solid #fff;
          border-radius: 100%;

          &:not(:first-of-type) {
            margin-left: -0.5rem;
          }
        }
      }

      .text {
        font-size: 1.2rem;
        color: #fff;
        font-weight: 500;
        line-height: 1.7rem;
      }
    }

    .block {
      padding: 1.2rem 1.9rem 1.9rem 1.4rem;
      margin: 1.2rem;
      background: #fff;
      border-radius: 1.2rem;
      display: flex;
      flex-direction: column;
      align-items: stretch;

      .goods {
        display: flex;

        & > .icon {
          flex: 0 0 14rem;
          height: 14.2rem;
          border-radius: 1rem;
          margin-right: 1.2rem;
          position: relative;
          overflow: hidden;

          .img {
            width: 100%;
            height: 100%;
          }

          .tip {
            width: 100%;
            height: 3.1rem;
            background: rgba(0, 0, 0, 0.38);
            color: #fff;
            font-size: 1.4rem;
            position: absolute;
            left: 0;
            bottom: 0;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }

        .info {
          display: flex;
          flex-direction: column;

          .title {
            font-size: 1.5rem;
            line-height: 2.4rem;
            font-weight: 500;
            color: #333;
          }

          .moods {
            align-self: flex-start;
            white-space: nowrap;
            margin: 1.2rem 0;
            padding: 0.2rem 0.3rem;
            background: #fee6dd;
            border-radius: 0.2rem;
            font-size: 1.1rem;
            color: #ff3800;
            display: flex;
            align-items: center;

            .icon {
              width: 1rem;
              height: 1.3rem;
              margin-right: 0.1rem;
            }
          }

          .money {
            width: 18.1rem;
            height: 6.1rem;
            background: url(~@/assets/groupBuy/money-bg.png);
            background-size: 100% 100%;
            background-repeat: no-repeat;
            margin-left: -0.6rem;
            position: relative;

            .old {
              font-size: 1rem;
              color: #999999;
              position: absolute;
              left: 0.6rem;
              top: 0.3rem;
            }

            .now {
              color: #fff;
              position: absolute;
              left: 8.8rem;
              top: 0.2rem;
              transform: translateX(-50%);

              .large {
                font-size: 1.4rem;
              }
            }
          }
        }
      }

      .countdown {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 1.2rem;
        font-weight: 500;
        margin: 1.5rem 0 2.4rem;

        &.disabled .item {
          background: #f5f6f7;
          color: #999999;
        }

        .label {
          color: #333;
          margin-right: 0.6rem;
        }

        .item {
          height: 1.8rem;
          background: #292929;
          border-radius: 0.4rem;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          margin: 0.1rem;
          padding: 0 0.4rem;
        }

        .divider {
          margin-left: 0.1rem;
        }
      }

      .photo {
        align-self: center;
        display: flex;

        .head {
          position: relative;

          .crown {
            position: absolute;
            width: 3.7rem;
            height: 3.1rem;
            top: -1.4rem;
            right: -0.8rem;
          }

          .item {
            margin: 0;
          }
        }

        .item {
          width: 4.8rem;
          height: 4.8rem;
          margin: 0 1.25rem;
          border-radius: 100%;
        }
      }

      .spec {
        align-self: center;
        font-size: 1.2rem;
        margin-top: 1.2rem;
        font-weight: 500;
        color: #999;
      }

      .desc {
        width: 28rem;
        height: 4rem;
        margin-top: 1.2rem;
        align-self: center;
        font-size: 1.4rem;
        color: #333;
        line-height: 2rem;
        font-weight: 500;
        text-align: center;

        .active {
          color: #fe3b04;
        }
      }

      .btn {
        margin-top: 1.5rem;
        align-self: center;
        // width: 24rem;
        // height: 4.4rem;
        // font-size: 1.5rem;
        // font-weight: 600;
        // color: #fff;
        // background: linear-gradient(180deg, #fe704f 0, #ff263b 100%);
        // border-radius: 2.2rem;
        // display: flex;
        // justify-content: center;
        // align-items: center;
      }
    }
  }
}
</style>
